import Transitions from "../../components/Transitions"
import * as S from "./styles"

const Projects = () => {
    return (
        <Transitions>
            <S.Container id="projects"></S.Container>
        </Transitions>
    )
}

export default Projects
